module.exports = __webpack_public_path__ + "static/img/level-7-1.e0580b54.png";